module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-footer"
  }, [(_vm.skew) ? _c('div', {
    staticClass: "skew-footer-top"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-5"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Index'
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "src": "/static/images/logo/white_right.svg",
      "alt": "Deveo logo"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\n                    " + _vm._s(_vm.$t('layout.footerAbout')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "locale-wrapper"
  }, _vm._l((_vm.locales), function(locale, index) {
    return _c('div', {
      key: index,
      staticClass: "locale",
      class: {
        'active': _vm.$i18n.locale === index
      },
      on: {
        "click": function($event) {
          _vm.$i18n.locale = index
        }
      }
    }, [(index === 'da') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/dk.png",
        "alt": "Danish"
      }
    }) : _vm._e(), _vm._v(" "), (index === 'en') ? _c('img', {
      attrs: {
        "src": "/static/images/flags/gb.png",
        "alt": "English"
      }
    }) : _vm._e()])
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('layout.footerMenuHeader')))]), _vm._v(" "), _vm._l((_vm.sortedSocials), function(social) {
    return _c('a', {
      key: social.name,
      attrs: {
        "href": social.link
      }
    }, [_vm._v("\n                    " + _vm._s(social.name) + "\n                ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3 contact"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('layout.footerContactHeader')))]), _vm._v(" "), _vm._l((_vm.contacts), function(contact) {
    return _c('a', {
      key: contact.icon,
      attrs: {
        "href": contact.link
      }
    }, [(contact.icon) ? _c('i', {
      class: 'fa fa-fw fa-' + contact.icon
    }) : _vm._e(), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(contact.title)
      }
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 copyright"
  }, [_vm._v("\n                2014 - " + _vm._s(_vm.currentYear) + " © Deveo ApS    |    CVR: 38994778\n            ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b083719"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/layout/footer.vue
// module id = 311
// module chunks = 1